import { defineComponent, openBlock, createElementBlock, createCommentVNode, createElementVNode, unref, createVNode, toDisplayString, createStaticVNode, Fragment, renderList, normalizeClass, withCtx, createTextVNode } from 'vue';
import { UiIcon } from '../../../icon/index.mjs';
import { UiButton } from '../../../button/index.mjs';
import { UiSimplebar } from '../../../simplebar/index.mjs';
import { ModulePickerEmits } from '../../src/types.mjs';
import { useComposable } from './src/composable.mjs';

const _hoisted_1 = { class: "ui-date-range-picker-candidate ui-picker-date ui-picker-time" };
const _hoisted_2 = { class: "ui-candidate-modules" };
const _hoisted_3 = { class: "ui-candidate-module" };
const _hoisted_4 = { class: "ui-candidates-header" };
const _hoisted_5 = { class: "ui-candidates-controls ui-candidates-left" };
const _hoisted_6 = { class: "ui-candidates-controls ui-candidates-right" };
const _hoisted_7 = { class: "ui-candidates-date" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "ui-candidate-module" };
const _hoisted_10 = { class: "ui-candidates-header" };
const _hoisted_11 = { class: "ui-candidates-context" };
const _hoisted_12 = { class: "ui-candidates-times" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "ui-candidates-footer" };
var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: ["confirm"],
  emits: ModulePickerEmits,
  setup(__props, { expose: __expose, emit: __emit }) {
    const emits = __emit;
    const { refs, nodes, methods, computeds } = useComposable(emits);
    const { cTime, cHours, cMinutes, cSeconds } = computeds;
    const { init, update } = methods;
    const { hourser, minuteser, secondser } = nodes;
    const { end, date, days, start, finish } = refs;
    __expose({ init, update });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createCommentVNode(" * \u9009\u62E9\u5668 "),
        createElementVNode("div", _hoisted_2, [
          createCommentVNode(" * \u65E5\u671F\u9009\u62E9\u5668 "),
          createElementVNode("div", _hoisted_3, [
            createCommentVNode(" * \u65E5\u671F\u9009\u62E9\u5668\u5934\u90E8 "),
            createElementVNode("div", _hoisted_4, [
              createCommentVNode(" * \u5DE6\u4FA7\u63A7\u5236\u5668 "),
              createElementVNode("div", _hoisted_5, [
                createCommentVNode(" * \u5E74\u4EFD\u63A7\u5236\u5668 "),
                createElementVNode("div", {
                  class: "ui-candidates-control ui-candidates-year",
                  onClick: _cache[0] || (_cache[0] = ($event) => unref(methods).date({ year: unref(date).getFullYear() - 1 }))
                }, [
                  createVNode(unref(UiIcon), { name: "arrow-double" })
                ]),
                createCommentVNode(" * \u6708\u4EFD\u63A7\u5236\u5668 "),
                createElementVNode("div", {
                  class: "ui-candidates-control ui-candidates-month",
                  onClick: _cache[1] || (_cache[1] = ($event) => unref(methods).date({ month: unref(date).getMonth() - 1 }))
                }, [
                  createVNode(unref(UiIcon), { name: "arrow" })
                ])
              ]),
              createCommentVNode(" * \u65E5\u671F\u5E74\u6708\u4FE1\u606F "),
              createElementVNode("div", {
                class: "ui-candidates-context ui-candidates-selector",
                onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("switchover", "month"))
              }, [
                createElementVNode(
                  "span",
                  null,
                  toDisplayString(unref(date).getFullYear()) + "\u5E74",
                  1
                  /* TEXT */
                ),
                createElementVNode(
                  "span",
                  null,
                  toDisplayString(unref(date).getMonth() + 1) + "\u6708",
                  1
                  /* TEXT */
                )
              ]),
              createCommentVNode(" * \u53F3\u4FA7\u63A7\u5236\u5668 "),
              createElementVNode("div", _hoisted_6, [
                createCommentVNode(" * \u6708\u4EFD\u63A7\u5236\u5668 "),
                createElementVNode("div", {
                  class: "ui-candidates-control ui-candidates-month",
                  onClick: _cache[3] || (_cache[3] = ($event) => unref(methods).date({ month: unref(date).getMonth() + 1 }))
                }, [
                  createVNode(unref(UiIcon), { name: "arrow" })
                ]),
                createCommentVNode(" * \u5E74\u4EFD\u63A7\u5236\u5668 "),
                createElementVNode("div", {
                  class: "ui-candidates-control ui-candidates-year",
                  onClick: _cache[4] || (_cache[4] = ($event) => unref(methods).date({ year: unref(date).getFullYear() + 1 }))
                }, [
                  createVNode(unref(UiIcon), { name: "arrow-double" })
                ])
              ])
            ]),
            createCommentVNode(" * \u65E5\u671F\u9009\u62E9\u5668\u5185\u5BB9 "),
            createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = createStaticVNode('<div class="ui-candidate-context">\u4E00</div><div class="ui-candidate-context">\u4E8C</div><div class="ui-candidate-context">\u4E09</div><div class="ui-candidate-context">\u56DB</div><div class="ui-candidate-context">\u4E94</div><div class="ui-candidate-context">\u516D</div><div class="ui-candidate-context">\u65E5</div>', 7)),
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList(unref(days), (value) => {
                  return openBlock(), createElementBlock("div", {
                    key: value.date,
                    class: normalizeClass(["ui-candidate", unref(methods).get_day_status(value)]),
                    onClick: ($event) => unref(methods).select({ date: value })
                  }, toDisplayString(value.day), 11, _hoisted_8);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ])
          ]),
          createCommentVNode(" * \u65F6\u95F4\u9009\u62E9\u5668 "),
          createElementVNode("div", _hoisted_9, [
            createCommentVNode(" * \u65F6\u95F4\u9009\u62E9\u5668\u5934\u90E8 "),
            createElementVNode("div", _hoisted_10, [
              createElementVNode(
                "div",
                _hoisted_11,
                toDisplayString(unref(cTime)),
                1
                /* TEXT */
              )
            ]),
            createCommentVNode(" * \u65F6\u95F4\u9009\u62E9\u5668\u5185\u5BB9 "),
            createElementVNode("div", _hoisted_12, [
              createVNode(
                unref(UiSimplebar),
                {
                  class: "ui-candidates-time",
                  ref_key: "hourser",
                  ref: hourser,
                  height: 300,
                  trigger: "Hover"
                },
                {
                  default: withCtx(() => [
                    (openBlock(), createElementBlock(
                      Fragment,
                      null,
                      renderList(24, (_, number) => {
                        return createElementVNode("div", {
                          class: normalizeClass(["ui-candidate", { "ui-active": unref(cHours) == number }]),
                          onClick: ($event) => unref(methods).select({ hours: number })
                        }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_13);
                      }),
                      64
                      /* STABLE_FRAGMENT */
                    ))
                  ]),
                  _: 1
                  /* STABLE */
                },
                512
                /* NEED_PATCH */
              ),
              createVNode(
                unref(UiSimplebar),
                {
                  class: "ui-candidates-time",
                  ref_key: "minuteser",
                  ref: minuteser,
                  height: 300,
                  trigger: "Hover"
                },
                {
                  default: withCtx(() => [
                    (openBlock(), createElementBlock(
                      Fragment,
                      null,
                      renderList(60, (_, number) => {
                        return createElementVNode("div", {
                          class: normalizeClass(["ui-candidate", { "ui-active": unref(cMinutes) == number }]),
                          onClick: ($event) => unref(methods).select({ minutes: number })
                        }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_14);
                      }),
                      64
                      /* STABLE_FRAGMENT */
                    ))
                  ]),
                  _: 1
                  /* STABLE */
                },
                512
                /* NEED_PATCH */
              ),
              createVNode(
                unref(UiSimplebar),
                {
                  class: "ui-candidates-time",
                  ref_key: "secondser",
                  ref: secondser,
                  height: 300,
                  trigger: "Hover"
                },
                {
                  default: withCtx(() => [
                    (openBlock(), createElementBlock(
                      Fragment,
                      null,
                      renderList(60, (_, number) => {
                        return createElementVNode("div", {
                          class: normalizeClass(["ui-candidate", { "ui-active": unref(cSeconds) == number }]),
                          onClick: ($event) => unref(methods).select({ seconds: number })
                        }, toDisplayString(number.toString().padStart(2, "0")), 11, _hoisted_15);
                      }),
                      64
                      /* STABLE_FRAGMENT */
                    ))
                  ]),
                  _: 1
                  /* STABLE */
                },
                512
                /* NEED_PATCH */
              )
            ])
          ])
        ]),
        createCommentVNode(" * \u63A7\u5236\u5668 "),
        createElementVNode("div", _hoisted_16, [
          createVNode(unref(UiButton), {
            size: "small",
            readonly: unref(finish) ? !unref(end) : !unref(start),
            onClick: unref(methods).confirm
          }, {
            default: withCtx(() => [
              createTextVNode(
                toDisplayString(__props.confirm),
                1
                /* TEXT */
              )
            ]),
            _: 1
            /* STABLE */
          }, 8, ["readonly", "onClick"])
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
